/** @private for use in `Repository` only */
export type Identifier = string | number;

/** @private for use in `Repository` only */
export type UrlRouteMap = Record<string, string>;

/** @private for use in `Repository` only */
export type UrlInjectionMap = Record<string, unknown>;

/**
 * Default Stale Time config for the Repository pattern.
 * 5 Minutes.
 */
export const RQ_STALE_TIME_MS = 300_000 as const;

/**
 * Struct to wrap paginator data returned from Django
 */
export type PaginatorContract<T> = {
  results: Array<T>;
  count: number;
  num_pages?: number;
  page_number?: number;
  next_page_number?: number;
  previous_page_number?: number;
};

/**
 *
 * @see Jira: https://showpass.atlassian.net/browse/SPW-9620
 * @deprecated Please use PaginatorContract from @shared/services/api/types instead
 */
export type PaginatedResponseType = {
  count: number;
  num_pages: number;
  page_number: number;
  next_page_number: number | null;
  previous_page_number: number | null;
};

export type PaginatedResponse<T> = {
  results: T[];
  count: number;
  num_pages?: number;
  page_number?: number;
  next_page_number?: number;
  previous_page_number?: number;
};
